import { Badge } from '@fluentui/react-components';

import { ASSESSMENT_VALUE_SOURCE, CONFIRMATION_STATE, TAssessmentFieldValue } from '../../models';

// A subtle origin label shown only where it clarifies why a value already exists:
//   - "From request"     a fact copied from the submitted request
//   - "Template default"  an organization-configured default
//   - "Suggested"         a template suggestion the assessor should confirm
// Once the assessor confirms or changes a value, the label is dropped so normal
// answers are not visually noisy.
export const OriginBadge = ({ value }: { value: TAssessmentFieldValue }) => {
  const untouched =
    value.confirmationState === CONFIRMATION_STATE.UNCONFIRMED ||
    value.confirmationState === CONFIRMATION_STATE.CONFIRMED_FROM_REQUEST;

  if (!untouched) return null;

  if (value.source === ASSESSMENT_VALUE_SOURCE.REQUEST) {
    return (
      <Badge appearance="tint" color="informative" size="small">
        From request
      </Badge>
    );
  }
  if (value.source === ASSESSMENT_VALUE_SOURCE.TEMPLATE_SUGGESTION) {
    return (
      <Badge appearance="tint" color="brand" size="small">
        Suggested
      </Badge>
    );
  }
  if (value.source === ASSESSMENT_VALUE_SOURCE.TEMPLATE_DEFAULT) {
    return (
      <Badge appearance="tint" color="subtle" size="small">
        Template default
      </Badge>
    );
  }
  return null;
};
